class ProductReviewsIOFit extends HTMLElement {
  constructor() {
    super();
    this.widgetObserver = null;
    this.resizeObserver = null;
    this.syncTimer = null;
  }

  connectedCallback() {
    this.renderFromMetafield();
  }

  disconnectedCallback() {
    if (this.widgetObserver) {
      this.widgetObserver.disconnect();
      this.widgetObserver = null;
    }

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }

    if (this.syncTimer) {
      window.clearTimeout(this.syncTimer);
      this.syncTimer = null;
    }
  }

  renderFromMetafield() {
    const rawValue = this.getAttribute('value')?.trim();
    const sizingValue = Number.parseFloat(rawValue);

    if (!Number.isFinite(sizingValue)) {
      this.hideSizingIndicator();
      return;
    }

    const clampedSizingValue = Math.min(Math.max(sizingValue, 1), 5);
    const leftValue = ((clampedSizingValue - 1) / 4) * 100;

    this.renderSizingIndicator(`${leftValue}%`);
  }

  renderSizingIndicator(leftValue) {
    const smallLabel = (typeof sizeIndicatorStrings !== 'undefined' && sizeIndicatorStrings.small) ? sizeIndicatorStrings.small : 'Small';
    const trueLabel = (typeof sizeIndicatorStrings !== 'undefined' && sizeIndicatorStrings.true) ? sizeIndicatorStrings.true : 'True to size';
    const bigLabel = (typeof sizeIndicatorStrings !== 'undefined' && sizeIndicatorStrings.big) ? sizeIndicatorStrings.big : 'Big';

    this.hidden = false;
    this.innerHTML = `<div class="product-sizing-slider__wrapper">
      <div class="product-sizing-slider__background">
        <div class="product-sizing-slider__track">
          <div class="product-sizing-slider__thumb" style="left: ${leftValue};"></div>
        </div>
      </div>
      <div class="product-sizing-slider__labels">
        <div class="product-sizing-slider__label">
          <span>${smallLabel}</span>
        </div>
        <div class="product-sizing-slider__label">
          <span>${trueLabel}</span>
        </div>
        <div class="product-sizing-slider__label">
          <span>${bigLabel}</span>
        </div>
      </div>
    </div>`;
  }

  hideSizingIndicator() {
    this.innerHTML = '';
    this.hidden = true;
  }
}

customElements.define('product-reviews-io-fit', ProductReviewsIOFit);

function applyReviewsIONativeWidgetLayout(widgets = Array.from(document.querySelectorAll('[id^="ReviewsWidget-"], #ReviewsWidget'))) {
  const hasEmptyWidget = hasEmptyReviewsWidget(widgets);
  const hasReviews = widgets.some((widget) => widget.querySelectorAll('.R-ContentList__item').length > 0);

  widgets.forEach((widget) => {
    const rightGroup = widget.querySelector('.ElementsWidget__header .header__group--right');
    const section = widget.closest('.shopify-section');

    if (rightGroup) {
      rightGroup.style.setProperty('display', 'none', 'important');
    }

    if (section) {
      section.hidden = isEmptyReviewsWidget(widget);
    }
  });

  document.querySelectorAll('.product__reviews-link').forEach((ratingLink) => {
    if (hasReviews) {
      ratingLink.hidden = false;
      return;
    }

    if (hasEmptyWidget) {
      ratingLink.hidden = true;
    }
  });
}

function hasEmptyReviewsWidget(widgets) {
  return widgets.some((widget) => isEmptyReviewsWidget(widget));
}

function isEmptyReviewsWidget(widget) {
  const reviewItems = widget.querySelectorAll('.R-ContentList__item');

  if (reviewItems.length > 0) {
    return false;
  }

  const text = widget.textContent?.trim()?.toLowerCase() || '';

  return [
    'no reviews collected',
    'be the first to write a review',
    'keine bewertungen',
    'noch keine bewertungen',
    'sei der erste',
    'sois le premier',
    'soyez le premier',
    'scrivi la prima recensione',
    'sé el primero'
  ].some((emptyStateText) => text.includes(emptyStateText));
}

function observeReviewsIONativeWidgets() {
  let syncTimer = null;

  const queueSync = () => {
    if (syncTimer) {
      return;
    }

    syncTimer = window.setTimeout(() => {
      syncTimer = null;
      applyReviewsIONativeWidgetLayout();
    }, 100);
  };

  queueSync();

  if (!document.body) {
    return;
  }

  const observer = new MutationObserver(queueSync);

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  });
}

function bindProductReviewsLinks() {
  document.addEventListener('click', (event) => {
    const ratingLink = event.target.closest('.product__reviews-link');

    if (!ratingLink) {
      return;
    }

    const fullReviewsWidget = Array.from(document.querySelectorAll('[id^="ReviewsWidget-"], #ReviewsWidget'))
      .find((widget) => !widget.closest('.apps-section--reviews-summary-only') && !widget.closest('.shopify-section')?.hidden);

    if (!fullReviewsWidget) {
      return;
    }

    event.preventDefault();
    fullReviewsWidget.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    observeReviewsIONativeWidgets();
    bindProductReviewsLinks();
  }, { once: true });
} else {
  observeReviewsIONativeWidgets();
  bindProductReviewsLinks();
}
